import * as PopoverPrimitive from '@radix-ui/react-popover'
import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * shadcn/ui's Popover over Radix (NFR-34).
 *
 * Deliberately a Popover and not a DropdownMenu, even though the ingredient row's `⋯` looks
 * like a menu button: what it opens contains a text input, and DropdownMenu is menu
 * semantics — `menuitem` roles, typeahead that swallows the keystrokes you meant for the
 * field, items that close on select. Popover is the primitive that takes arbitrary
 * interactive content, which is what a note field plus a checkbox plus a delete actually is.
 */
export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverAnchor = PopoverPrimitive.Anchor

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'end', sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      // `collisionPadding` keeps it clear of the notch and the fixed save bar at 375px,
      // where an end-aligned popover otherwise hangs off the edge of the screen.
      collisionPadding={12}
      className={cn(
        'z-50 w-72 max-w-[calc(100vw-1.5rem)] rounded-xl border border-stone-200 bg-white p-3 shadow-lg outline-none dark:border-stone-800 dark:bg-stone-900',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName
